<template>
  <b-modal
    :visible="value"
    title="Chọn thiết bị"
    @hide="closeModal"
    size="xl"
    ignore-enforce-focus-selector="input"
  >
    <!-- content -->
    <div>
      <div class="card p-10 pt-15 b-t-1-869fb229">
        <div class="card-header m-b-10">
          <form class="box-search" @submit.prevent="submitForm">
            <div class="form-group">
              <input
                type="text"
                v-model.trim="search.key"
                class="form-control f12 hc-37 text-search"
                placeholder="Serial/tên MC/gmail MC/SĐT"
                @keyup.enter="submitForm"
              />
            </div>

            <div class="form-group">
              <Select2
                v-model="search.emailSale"
                :options="Config.getSearch(optionsListUserByEmail)"
                placeholder="CVKD"
              />
            </div>
            <div class="form-group">
              <Select2
                placeholder="Trạng thái nhận file"
                v-model="search.stateFileContract"
                :options="Config.getSearch(Config.statusFileContractOptions)"
              >
              </Select2>
            </div>

            <div class="form-group">
              <Select2MultipleControl
                :settings="{ placeholder: 'Trạng thái', closeOnSelect: false }"
                v-model="search.status"
                :options="statusDeviceKpi"
              >
              </Select2MultipleControl>
            </div>
            <div class="form-group">
              <!-- dataRegion -->
              <Select2MultipleControl
                :settings="{ placeholder: 'Vùng', closeOnSelect: false }"
                v-model="search.regionIds"
                :options="dataRegion"
              >
              </Select2MultipleControl>
            </div>

            <div class="form-group form-group-action">
              <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
                <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
              </button>
              <button
                type="button"
                class="btn btn-outline-light hc-37 mr-2 pt-2"
                @click="removeForm"
              >
                <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
              </button>
            </div>
          </form>
        </div>
        <div class="card-body">
          <div class="tab-content" id="nav-tabContent">
            <div class="p-10">
              Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
              <span v-if="selectedIds.length"> - đã chọn {{ selectedIds.length }}</span>
              <b-button
                v-show="selectedIds.length"
                variant="danger"
                size="sm"
                class="ml-2"
                @click="onRemoveAllSelected"
                >Bỏ chọn {{ selectedIds.length }} thiết bị</b-button
              >
              <b-table
                :busy.sync="tbLoading"
                sticky-header
                responsive
                hover
                :items="lists"
                :fields="filterTable"
                :fixed="true"
                :bordered="true"
                style="max-height: calc(100vh - 450px)"
                show-empty
                empty-text="Không có dữ liệu!"
                class="mt-2"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #head(selected)>
                  <b-form-checkbox
                    v-if="selectedIds.length > 0"
                    v-model="stateCheckAll"
                    @change="checkAllKpi"
                  ></b-form-checkbox>
                </template>
                <template #cell(selected)="data">
                  <b-form-checkbox
                    v-if="
                      statusFileContractSelected === null ||
                      statusFileContractSelected === data.item.statusFileContract
                    "
                    class="text-center"
                    v-model="selectedIds"
                    :value="data.item.id"
                    @change="stateCheckAll = false"
                  ></b-form-checkbox>
                </template>
                <template #cell(merchantEmail)="data">
                  <p><b>Tên:</b> {{ data.item.merchantName }}</p>
                  <p><b>Email:</b> {{ data.item.merchantEmail }}</p>
                  <p><b>SĐT:</b> {{ data.item.merchantMobile }}</p>
                  <p><b>Địa chỉ:</b> {{ data.item.merchantAddress }}</p>
                </template>
                <template #cell(emailSale)="data">
                  <p><b>Tên:</b> {{ data.item.nameSale }}</p>
                  <p><b>Email:</b> {{ data.item.emailSale }}</p>
                </template>
                <template #cell(packageType)="data">
                  <p v-if="data.item.packageType">Loại gói: {{ data.item.packageType }}</p>
                  <p v-if="data.item.duration">Thời hạn: {{ data.item.duration }}</p>
                </template>
                <template #cell(statusFileContract)="data">
                  <p>
                    {{
                      data.item.statusFileContract | transformData(Config.statusFileContractOptions)
                    }}
                  </p>
                </template>
                <template #cell(status)="data">
                  <span class="badge" :class="data.item.status">
                    {{ data.item.status | transformData(Config.statusDeviceKpi) }}
                  </span>
                </template>
              </b-table>
            </div>
          </div>
          <div class="pagination-bottom my-0">
            <b-pagination
              v-model="search.page"
              :total-rows="pagination.total"
              :per-page="search.limit"
              class="fl-right mr-2"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="" @click="closeModal" class="ml-2"> Đóng </b-button>
        <b-button
          variant="danger"
          @click="onSubmit('NOT_RECEIVED')"
          :disabled="selectedIds.length === 0 || statusFileContractSelected === 'NOT_RECEIVED'"
          class="ml-2"
        >
          Chuyển sang chưa nhận file HĐ
        </b-button>
        <b-button
          variant="primary"
          @click="onSubmit('RECEIVED')"
          :disabled="selectedIds.length === 0 || statusFileContractSelected === 'RECEIVED'"
          class="ml-2"
        >
          Chuyển sang đã nhận file HĐ
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import { getListUserFnByEmail } from '../kpiRecordMx'

  const rawSearch = {
    emailSale: null,
    key: null,
    status: null,
    stateFileContract: null,
    regionId: null,
    limit: 20,
    page: 1,
  }
  const fieldsTable = [
    { key: 'selected', label: '', thStyle: '' },
    { key: 'service', label: 'Dịch vụ', thStyle: '' },
    { key: 'merchantEmail', label: 'Merchant', thStyle: 'min-width: 170px' },
    { key: 'contractCode', label: 'Mã hợp đồng', thStyle: '' },
    { key: 'appendixCode', label: 'Mã phụ lục', thStyle: '' },
    { key: 'serial', label: 'Serial TB', thStyle: '' },
    { key: 'packageType', label: 'Loại gói & Thời hạn' },
    { key: 'emailSale', label: 'CVKD', thStyle: 'min-width: 170px' },
    { key: 'status', label: 'Trạng thái KPI', thStyle: '' },
    { key: 'statusFileContract', label: 'Trạng thái nhận file', thStyle: '' },
  ]

  export default {
    props: ['value'],
    data() {
      return {
        moment,
        Config,
        filterTable: fieldsTable,
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: cloneDeep(rawSearch),
        pagination: {
          total: 0,
        },
        lists: [],

        optionsListUserByEmail: [],
        selectedIds: [],
        stateCheckAll: false,
        statusFileContractSelected: null,
        dataRegion: [],

        // - Chỉ hiển thị các KPI ở trạng thái sau: /Chờ GS duyệt/Cần bổ sung/Cần giải trình/Hoàn thành
        statusDeviceKpi: [
          { id: 'WAIT_MONITOR_APPROVE', text: 'Chờ giám sát duyệt' },
          { id: 'EXPLANATION', text: 'Cần SA giải trình' },
          { id: 'ADDITIONAL', text: 'Cần SA bổ sung' },
          { id: 'SUCCESS', text: 'Hoàn thành' },
        ],
      }
    },
    created() {
      this.fetchData()
      this.getListUser()
      this.getRegion()
    },
    watch: {
      'search.page': function () {
        this.fetchData()
        this.stateCheckAll = false
      },
      selectedIds: {
        handler() {
          if (this.selectedIds.length === 0) {
            this.statusFileContractSelected = null
            return
          }
          if (this.selectedIds.length === 1) {
            const item = this.lists.find(e => e.id === this.selectedIds[0])
            this.statusFileContractSelected = item.statusFileContract
          }
        },
        deep: true,
      },
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      },
      async onSubmit(stateFileContract = null) {
        if (this.selectedIds.length === 0 || !stateFileContract) return

        const flag = await this.approveMx(
          `Bạn có chắc chắn muốn cập nhật trạng thái nhận file của ${this.selectedIds.length} thiết bị này thành ${stateFileContract === 'NOT_RECEIVED' ? '"Chưa nhận file HĐ"' : '"Đã nhận file HĐ"'}`
        )
        if (!flag) return

        // ids: <array>
        // stateFileContract: RECEIVED/NOT_RECEIVED
        const params = {
          ids: [...this.selectedIds],
          stateFileContract,
        }
        console.log(22, params)
        try {
          this.showLoading = true
          const response = await DeviceService.deviceKpiChangeFileStatus(params)
          if (response.code === 1000) {
            this.showLoading = false
            this.showSuccessMx('Cập nhật trạng thái nhận file thành công.')
            this.selectedIds = []
            this.fetchData()
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
          return false
        } finally {
          this.showLoading = false
        }
      },
      checkAllKpi() {
        if (this.statusFileContractSelected === null) return
        const status = this.statusFileContractSelected

        if (this.stateCheckAll) {
          this.lists.map(item => {
            if (item.statusFileContract === status) {
              this.selectedIds.push(item.id)
            }
          })
        } else {
          const allKpiIdInList = this.lists
            ?.filter(item => item.statusFileContract === status)
            ?.map(item => item.id)
          this.selectedIds = this.selectedIds.filter(id => !allKpiIdInList.includes(id))
        }
        // remove dulicates
        this.selectedIds = Array.from(new Set(this.selectedIds))
      },

      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      removeForm() {
        this.search = { ...this.search, ...cloneDeep(rawSearch) }
        this.fetchData()
      },
      async onRemoveAllSelected() {
        const flag = await this.approveMx('Bạn có chắc chắn muốn bỏ chọn tất cả các KPI đã chọn')
        if (!flag) return

        this.selectedIds = []
      },

      async getListUser() {
        this.optionsListUserByEmail = await getListUserFnByEmail()
      },
      async getRegion() {
        try {
          const data = await StaffService.getListRegions()
          if (data.data.length > 0) {
            this.dataRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        console.log('fetch data')
        try {
          this.tbLoading = true
          const params = {
            ...rawSearch,
            ...this.search,
          }
          // remove data null and '0'
          for (const key in params) {
            if (
              params[key] === null ||
              params[key] === '0' ||
              (Array.isArray(params[key]) && params[key].length === 0)
            ) {
              delete params[key]
              delete this.search[key]
            }
          }
          // - Chỉ hiển thị các KPI ở trạng thái sau: /Chờ GS duyệt/Cần bổ sung/Cần giải trình/Hoàn thành
          // check status
          if (!params.status || params.status.length === 0) {
            const allStatus = this.statusDeviceKpi.map(e => e.id)
            params.status = allStatus
          }
          // console.log(params)
          const response = await DeviceService.deviceKpiGetList(params)
          if (response.code === 1000) {
            this.lists = response.data.kpiAggregateRes
            this.pagination.total = response.data.count
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },
    },
  }
</script>

<style>
  .form-group .select2-search__field {
    width: 100% !important;
  }
</style>
